import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Activity, Building2, Handshake, Megaphone, Users } from "lucide-react";
import { useAdminApi } from "@/lib/api";

const CARDS = [
  { k: "player", l: "Player registrations", i: Users },
  { k: "franchise", l: "Franchise enquiries", i: Building2 },
  { k: "sponsor", l: "Sponsorship enquiries", i: Handshake },
  { k: "media", l: "Media enquiries", i: Megaphone },
];

const when = (d) => new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export default function Overview() {
  const req = useAdminApi();
  const [d, setD] = useState(null);
  useEffect(() => { req("get", "/admin/overview").then(setD).catch(() => {}); }, [req]);
  if (!d) return <p className="text-slate-400">Loading…</p>;
  return (
    <div data-testid="admin-overview" className="space-y-8">
      <h1 className="font-display text-4xl uppercase">Overview</h1>
      <div className="grid grid-cols-2 gap-px overflow-hidden rounded-md border border-white/10 bg-white/10 lg:grid-cols-4">
        {CARDS.map(({ k, l, i: I }) => (
          <Link key={k} to={`/admin/enquiries/${k}`} data-testid={`overview-count-${k}`} className="bg-[#112240] p-5 transition-colors hover:bg-[#1A365D]">
            <I className="h-5 w-5 text-[#00E5FF]" />
            <p className="mt-4 font-score text-4xl font-bold">{d.counts[k]}</p>
            <p className="text-xs uppercase tracking-wider text-slate-400">{l}</p>
            {d.new[k] > 0 && <p className="mt-1 text-xs font-bold text-[#FF8a65]">{d.new[k]} new</p>}
          </Link>
        ))}
      </div>
      <div className="grid gap-6 xl:grid-cols-[1.4fr_1fr]">
        <section className="rounded-md border border-white/10 bg-[#112240]">
          <h2 className="border-b border-white/10 p-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-300">Recent enquiries</h2>
          {d.recent.length ? (
            <ul data-testid="overview-recent" className="divide-y divide-white/5">
              {d.recent.map((r) => (
                <li key={r.id}><Link to={`/admin/enquiries/${r.kind}?open=${r.id}`} className="flex items-center justify-between gap-3 p-4 text-sm hover:bg-white/5">
                  <span><span className="font-semibold">{r.name}</span> <span className="text-slate-500">· {r.email}</span></span>
                  <span className="flex shrink-0 items-center gap-3 text-xs"><span className="rounded-sm bg-white/10 px-2 py-0.5 uppercase">{r.kind}</span><span className="text-slate-500">{when(r.created_at)}</span></span>
                </Link></li>
              ))}
            </ul>
          ) : <p className="p-6 text-sm text-slate-400">No enquiries yet.</p>}
        </section>
        <section className="rounded-md border border-white/10 bg-[#112240]">
          <h2 className="flex items-center gap-2 border-b border-white/10 p-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-300"><Activity className="h-4 w-4" />Recent website activity</h2>
          <ul data-testid="overview-activity" className="divide-y divide-white/5">
            {d.activity.map((a) => <li key={a.id} className="p-4 text-sm"><p>{a.text}</p><p className="text-xs text-slate-500">{when(a.created_at)}</p></li>)}
            {!d.activity.length && <li className="p-6 text-sm text-slate-400">No activity yet.</li>}
          </ul>
        </section>
      </div>
      <div className="grid grid-cols-3 gap-px overflow-hidden rounded-md border border-white/10 bg-white/10 md:grid-cols-6">
        {Object.entries(d.content).map(([k, v]) => (
          <Link key={k} to={`/admin/content/${k}`} className="bg-[#112240] p-4 hover:bg-[#1A365D]"><p className="font-score text-2xl font-bold">{v}</p><p className="text-[10px] uppercase tracking-widest text-slate-400">{k}</p></Link>
        ))}
      </div>
    </div>
  );
}
